import tenantRouterOptions from "#build/tenant-router.options";
import routerOptions0 from "/app/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
  ...tenantRouterOptions,
...routerOptions0,
}